import { IIconProps, IIconStyles } from "@fluentui/react/lib/Icon";
import {
  IProcessedStyleSet,
  mergeStyleSets,
} from "@fluentui/react/lib/Styling";
import { memoizeFunction } from "@fluentui/react/lib/Utilities";

import { AppLabelStatusBaseStyles } from "./AppLabelStatusBaseProps";

export const getAppLabelStatusBaseStyles = memoizeFunction(
  (
    customStyles?: AppLabelStatusBaseStyles
  ): IProcessedStyleSet<AppLabelStatusBaseStyles> => {
    const defaultLabelStyles: AppLabelStatusBaseStyles = {
      root: {
        display: "flex",
        flexWrap: "nowrap",
        alignItems: "center",
        userSelect: "none",
        padding: "0px 10px",
      },
      label: {
        fontWeight: 400,
        cursor: "default !important",
      },
    };
    return mergeStyleSets(defaultLabelStyles, customStyles);
  }
);

export const getAppLabelStatusBaseIconStyles = memoizeFunction(
  (iconProps: IIconProps): IIconStyles => {
    const defaultIconStyles: IIconStyles = {
      root: {
        width: 20,
        height: 20,
        alignItems: "center",
        paddingRight: 10,
      },
    };
    return mergeStyleSets(defaultIconStyles, iconProps.styles);
  }
);
